import React from "react"
import PropTypes from 'prop-types'

import SelectGenericNew from "../../../../../gd-ui/select-generic-new/select-generic-new"
import FieldRag_DropdownOption from "../../components/dropdown/option";
import FieldRag_DropdownValueNotEmpty from "../../components/dropdown/value-not-empty";
import {FieldAutomationConditionFormProps} from "../../../../render/automation-condition-form";

const debug = false
// const debug = "RagConditionForm"

export default class FieldRag_AutomationConditionForm extends React.Component<FieldAutomationConditionFormProps,any> {

    static propTypes = {
        field           : PropTypes.object,
        config          : PropTypes.object,

        options         : PropTypes.array,

        onChangeCallback: PropTypes.func,
    }

    constructor(props:FieldAutomationConditionFormProps) {
        super(props)

        this.state = {
            value: _.get(props.config, 'value', null)
        }
    }

    onChangeToValue = (option:any) => {
        const value = option.value

        this.setState({
            value
        }, ()=>{
            this.props.onChangeCallback({value})
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state)

        return (
            <div className="flex-row-left-top">
                <div className="label w-100">is</div>
                <SelectGenericNew className                     = "selector w-180"
                                  options                       = {this.props.field.getAutomationOptions()}
                                  value                         = {this.state.value}
                                  popoverScrollContainerClasses = "max-h-200 max-w-300"
                                  valueComponent                = {FieldRag_DropdownValueNotEmpty}
                                  popoverOptionComponent        = {FieldRag_DropdownOption}
                                  isSearchable                  = {true}
                                  disabled                      = {this.props.config.disabled}
                                  onChange                      = {this.onChangeToValue}/>
            </div>
        )
    }
}
